import { createLucideIcon } from "lucide-react";

export const ChevronUpDown = createLucideIcon(
    "ChevronUpDown",
    [
        [
            "path",
            {
                d: "M4.6667 10L8 13.3333L11.3333 10",
                key: "feymty",
            },
        ],
        [
            "path",
            {
                d: "M4.6667 6L8 2.6667L11.3333 6",
                key: "1lb6pp",
            },
        ],
    ],
);
